import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import { LOGIN_URL, PRIVACY_POLICY_ROUTE, TERMS_OF_SERVICE_ROUTE } from '../../constants'
import { Colors, Spacing, Typography } from '../../styles'
import { GoogleSignInButtonImage } from '../atoms/buttons/GoogleSignInButton'

const Container = styled.div`
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    padding: ${Spacing._16};
    background-color: ${Colors.background.page};
`
const Actions = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${Spacing._12};
    width: 360px;
    max-width: 100%;
`
const Link = styled.a`
    width: 200px;
    max-width: 100%;
`
const Agreement = styled.p`
    margin: 0;
    color: ${Colors.text.secondary};
    font-family: ${Typography.fontFamily.sans};
    text-align: center;
    ${Typography.body.small};

    a,
    a:visited {
        color: inherit;
        text-decoration: underline;
    }
`

const GoogleAuthScreen = () => {
    const [searchParams] = useSearchParams()
    const authUrl = searchParams.get('authUrl') ?? LOGIN_URL
    const isSignIn = !searchParams.has('authUrl')

    return (
        <Container>
            <Actions>
                <Link href={authUrl} target="_self">
                    {GoogleSignInButtonImage}
                </Link>
                {isSignIn && (
                    <Agreement>
                        By continuing, you agree to General Task&#39;s{' '}
                        <a href={`/${TERMS_OF_SERVICE_ROUTE}`}>Terms of Service</a> and acknowledge the{' '}
                        <a href={`/${PRIVACY_POLICY_ROUTE}`}>Privacy Policy</a>.
                    </Agreement>
                )}
            </Actions>
        </Container>
    )
}

export default GoogleAuthScreen
